import { useState } from "react";
import { PlatformLayout } from "./platform-layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Download, Search } from "lucide-react";
import { ProspectsSpreadsheet } from "@/components/spreadsheet/prospects-spreadsheet";

export default function PlatformProspectsPage() {
  const [searchQuery, setSearchQuery] = useState("");

  function handleExport() {
    window.open("/api/platform/prospects/export/csv", "_blank");
  }

  return (
    <PlatformLayout fullBleed>
      <div className="flex flex-col h-full" data-testid="page-platform-prospects">
        {/* Header */}
        <div className="px-6 py-4 border-b flex items-center justify-between gap-4 flex-wrap flex-shrink-0">
          <div>
            <h1 className="text-xl font-semibold">Prospects</h1>
            <p className="text-sm text-muted-foreground mt-0.5">
              Manage your platform-level sales pipeline. Click any cell to edit.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <div className="relative">
              <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
              <Input
                placeholder="Search prospects…"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="pl-8 h-9 w-56"
                data-testid="input-search-prospects"
              />
            </div>
            <Button variant="outline" size="sm" onClick={handleExport} data-testid="button-export-csv">
              <Download className="w-4 h-4 mr-1.5" /> Export CSV
            </Button>
          </div>
        </div>

        {/* Spreadsheet */}
        <div className="flex-1 overflow-hidden">
          <ProspectsSpreadsheet searchQuery={searchQuery} />
        </div>
      </div>
    </PlatformLayout>
  );
}
